import { BloombergEpisodesPageProvider } from "../episodes-context";
import { BloombergEpisodesPageUi } from "./BloombergEpisodesPageUi";

export const OneFootballEpisodesPage = () => {
  return (
    <BloombergEpisodesPageProvider>
      <BloombergEpisodesPageUi />
    </BloombergEpisodesPageProvider>
  );
};
